import type { PatientNote } from '../../../services/patient/notes';

export const MAX_NOTE_TITLE_LENGTH = 120;
export const MAX_NOTE_BODY_LENGTH = 20000;

/**
 * Whether the current doctor may edit/delete a given note. Every note a
 * doctor can see is already `visibility: 'external'` (the server hard-filters
 * this), so today every visible note is manageable. Kept as a function of
 * the note rather than a hardcoded `true` so this policy can be tightened
 * later (e.g. author-only edits) without touching every call site.
 */
export function canManageNote(_note: PatientNote): boolean {
    return true;
}
